module.exports = __webpack_public_path__ + "img/b024e32.png";